// extracted by mini-css-extract-plugin
export var fluid = "card-module--fluid--2rdKF";
export var item = "card-module--item--Axpcz";
export var link = "card-module--link--WmHME";
export var visual = "card-module--visual--Zdl3d";
export var ad = "card-module--ad--mTF42";
export var title = "card-module--title---bVeb";
export var fadein = "card-module--fadein--bay4t";